module.exports = __webpack_public_path__ + "media/images/icheck/aero_dam-7ba50472b4afd2aac82e738592e27d56.png";